import { atom, useAtomValue, useSetAtom } from 'jotai';

export function createTimeMapState<T = Record<string, number>>() {
  const state = atom<T>({} as T);

  const useStateValue = () => {
    return useAtomValue(state);
  };

  const useSetStateValue = () => {
    return useSetAtom(state);
  };

  return {
    state,
    useStateValue,
    useSetStateValue,
  };
}

const {
  state: unreadCountTimeMapState,
  useStateValue: useUnreadCountTimeMapStateValue,
  useSetStateValue: useSetUnreadCountTimeMapStateValue,
} = createTimeMapState();

export {
  unreadCountTimeMapState,
  useUnreadCountTimeMapStateValue,
  useSetUnreadCountTimeMapStateValue,
};

const {
  state: officialReadTimeMapState,
  useStateValue: useOfficialReadTimeMapStateValue,
  useSetStateValue: useSetOfficialReadTimeMapStateValue,
} = createTimeMapState();

export {
  officialReadTimeMapState,
  useOfficialReadTimeMapStateValue,
  useSetOfficialReadTimeMapStateValue,
};

const {
  state: assistantReadTimeMapState,
  useStateValue: useAssistantReadTimeMapStateValue,
  useSetStateValue: useSetAssistantReadTimeMapStateValue,
} = createTimeMapState();

export {
  assistantReadTimeMapState,
  useAssistantReadTimeMapStateValue,
  useSetAssistantReadTimeMapStateValue,
};
